// extracted by mini-css-extract-plugin
export default {"root":"tooltip-question_root__AB0vb"};